// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3NfMk","inputWrap":"styles_inputWrap__1Q_1j","input":"styles_input__XQGpp"};